module.exports = __webpack_public_path__ + "static/media/A7407848.fcd54e2d.jpg";